import {Component, Inject} from '@angular/core';

import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';

@Component({
    selector: 'app-dialog-refill-offer-confirm',
    templateUrl: './refill-offer-confirm-dialog.component.html',
    styleUrls: ['./refill-offer-confirm-dialog.component.scss'],
    standalone: false
})
export class RefillOfferConfirmDialogComponent {

  offerNumber: string = '';

  constructor(public dialogRef: MatDialogRef<RefillOfferConfirmDialogComponent>, @Inject(MAT_DIALOG_DATA) data) {
    this.offerNumber = data.offerNumber;
  }

}
